<template>
  <div>
    <toolbar transparent fixed :logo="false" :back="false">
      <template v-slot:left>
        <div class="v-toolbar__button" @click="confirmExit">
          <v-icon icon="close" />
        </div>
      </template>
    </toolbar>

    <alert-dialog
      title="Leave workout?"
      :actions="[
        {
          title: 'No, continue',
          callback: resume
        },
        {
          title: 'Finish Workout',
          callback: complete
        }
      ]"
      :show="showDialog"
      @close="resume"
    >
      Are you sure you want to exit this workout in progress?
    </alert-dialog>
  </div>
</template>

<script>
import EventBus, { EVENTS } from "@/lib/event-bus"

import Toolbar from "@/components/Toolbar"
import AlertDialog from "@/components/AlertDialog"

export default {
  components: {
    Toolbar,
    AlertDialog
  },

  data() {
    return {
      showDialog: false
    }
  },

  methods: {
    resume() {
      this.showDialog = false
      this.$emit("resume")
      EventBus.$emit(EVENTS.WORKOUT_RESUMED)
    },

    complete() {
      this.showDialog = false
      this.$emit("complete")
    },

    confirmExit() {
      this.$emit("exitAttempted")
      EventBus.$emit(EVENTS.WORKOUT_EXIT_ATTEMPTED)
      this.showDialog = true
    }
  }
}
</script>
